import { render, staticRenderFns } from "./CommonGrid.vue?vue&type=template&id=1d4d4de4&scoped=true"
import script from "./CommonGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./CommonGrid.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../frontend-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4d4de4",
  null
  
)

export default component.exports